import { render, staticRenderFns } from "./TopicComposerModal.vue?vue&type=template&id=55f9dda0&scoped=true&"
import script from "./TopicComposerModal.vue?vue&type=script&lang=js&"
export * from "./TopicComposerModal.vue?vue&type=script&lang=js&"
import style0 from "./TopicComposerModal.vue?vue&type=style&index=0&id=55f9dda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9dda0",
  null
  
)

export default component.exports